<template>
    <b-container>
        <b-row v-if="!match.id">
            <b-col cols="12" md="12" class="mb-3">
                <inter-select
                        ref="matchSelect"
                        placeholder="Seleziona Partita"
                        v-model="match.idSelected"
                        @onSelected="onChangeMatch"
                >
                </inter-select>
            </b-col>
        </b-row>

        <b-row>
            <b-col cols="12" md="6" class="mb-3">
                <inter-input
                        label="Soglia biglietti"
                        v-model="match.tickets_threshold"
                        icon="armchair"
                        :error="errors.tickets_threshold">
                </inter-input>
            </b-col>
            <b-col cols="12" md="6" class="mb-3">
                <inter-input
                    label="Prezzo"
                    v-model="match.price"
                    icon="euro"
                    :error="errors.price">
                </inter-input>
            </b-col>
            <b-col cols="12" md="6" class="mb-3" style="display:none;">
                <inter-select
                        label="Adulti per minore"
                        v-model="match.adult_vs_childs"
                        :option-selected="match.adult_vs_childs"
                        :options="[
                                { name: '1 : 1', value: 1},
                                { name: '2 : 1', value: 2}
                                ]"
                >
                </inter-select>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="6" class="mb-3">
                <inter-input
                        label="Inizio vendita"
                        v-model="match.start_request"
                        type="date-autocomplete"
                        icon="calendar"
                        :error="errors.start_request">
                </inter-input>
            </b-col>
            <b-col cols="12" md="6" class="mb-3">
                <inter-input
                        label="Fine vendita"
                        v-model="match.end_request"
                        type="date-autocomplete"
                        icon="calendar"
                        :error="errors.end_request">
                </inter-input>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import InterInput from "../../../components/form/inter-input/InterInput";
    import Match from "@/models/Match";
    import InterSelect from "../../../components/form/inter-select/InterSelect";

    export default {
        name: "AdminMatchForm",
        components: {InterSelect, InterInput},
        data() {
            return {
                errors: {}
            }
        },
        props: {
            match: {
                type: Object,
                default: () => Object.assign({}, Match)
            },
            matches: {
                type: Array,
                default: () => []
            }
        },
        watch: {
            matches: function(val) {
                if(!this.match.id) {
                    this.$refs.matchSelect.selectOptions = val;
                }
          }
        },
        methods: {

            onChangeMatch: function(item) {
                this.$emit('onChangeMatch', item);
            },
            validate: function () {
                // this.errors = {};
                // if (this.user.name === '') {
                //     this.errors.name = true;
                // }
                // if (this.user.surname === '') {
                //     this.errors.surname = true;
                // }
                //
                // if (this.user.email === '') {
                //     this.errors.email = true;
                // }
                //
                // if (_.isEmpty(this.errors)) {
                //     return true;
                // } else {
                //     this.$bvToast.toast('Mi manca qualche dato', {
                //         title: 'Alert',
                //         variant: 'warning'
                //     });
                //     return false;
                // }
            }
        }
    }
</script>

<style scoped>

</style>
